module.exports = __webpack_public_path__ + "media/images/next-5ffea07d248570457cec0ad65a608ac7.svg";